module.exports = __webpack_public_path__ + "img/Printing_1200x800.84cc4458.png";